import http from "../http-common";


const getWMSVersions = () => {
  return http.get("/get-wms-versions-list");
};
const WMSVersionService = {
    getWMSVersions
}
export default WMSVersionService;